// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const AssignmentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M17.37 3H9.54C7.43 3 5.72 4.12 4.8 6.03c-.1.2 0 .4.1.5.1.2.3.2.5.2 1.31-.4 4.33.2 5.63 2.82 1.51 3.01.1 5.12-.6 5.72-.1.1-.2.3-.2.5s.1.3.3.4c1 .41 2.71 1.72 2.71 4.03 0 .3.2.5.5.5h3.52c3.12 0 5.23-2.21 5.23-5.43V8.53c.1-3.31-2.01-5.52-5.13-5.52"
        clipRule="evenodd"
        opacity=".5"
      />
      <path d="M16.07 17.47h2.3c.4 0 .81-.4.81-.8 0-.5-.4-.8-.8-.8h-2.31c-.5 0-.8.4-.8.8 0 .5.4.8.8.8" />
      <path
        fillRule="evenodd"
        d="M6.22 16.87c-3.21 0-4.72 1.81-4.72 3.62 0 .3.2.5.5.5h8.44c.3 0 .5-.2.5-.5 0-1.81-1.5-3.62-4.72-3.62m0-1.61c1.81 0 3.22-1.4 3.22-3.21 0-1.8-1.41-3.21-3.22-3.21-1.8 0-3.21 1.4-3.21 3.21 0 1.8 1.4 3.21 3.21 3.21"
        clipRule="evenodd"
      />
    </g>
  </SvgIcon>
);

export default AssignmentIcon;
